import { render } from "./Usdt.vue?vue&type=template&id=6b30f804&ts=true"
import script from "./Usdt.vue?vue&type=script&lang=ts"
export * from "./Usdt.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__